import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
import { SnackbarProvider } from 'notistack';
import { ConfirmProvider } from "material-ui-confirm";
import ButtonCloseSnackbar from './Components/Forms/ButtonCloseSnackbarComponent';

let hostname = `api-${window.location.hostname}`;
if (hostname.includes('localhost')) {
  hostname = 'localhost:8000';
}

axios.defaults.baseURL = `${window.location.protocol}//${hostname}/api/`;

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if ((error.response == null || error.response.status === 401) &&
        originalRequest.url.indexOf('login') < 0 &&
        originalRequest.url.indexOf('/rotograma/') < 0)
    {
      window.location.href = '/login';
      await axios.post('sair');
    }

    return Promise.reject(error)
  }
)

const iconVariant = {
  success: '✅ ',
  error: '✖️ ',
  warning: '⚠️ ',
  info: 'ℹ️ ',
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ConfirmProvider>
    <SnackbarProvider
      action={(id: any) => (<><ButtonCloseSnackbar id={id} /></>)}
      maxSnack={7}
      preventDuplicate={true}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
      iconVariant={iconVariant}>
        <App />
    </SnackbarProvider>
  </ConfirmProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
